import { Icon } from "@chakra-ui/icons"
import React from "react"

const InstagramBoldIcon = props => {
  return (
    <Icon viewBox="0 0 15.73 15.73" {...props}>
      <g>
        <path
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          d="M.5.5h14.73v14.73H.5z"
        />
        <circle cx="9.84" cy="5.87" r=".46" fill="currentColor" />
        <circle
          cx="7.87"
          cy="7.86"
          r="1.64"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <rect
          x="4.58"
          y="4.49"
          width="6.57"
          height="6.76"
          rx="1.6"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
      </g>
    </Icon>
  )
}

export default InstagramBoldIcon
